import type { InventoryStockTransaction } from '../types/inventory';

// F1 · espejo de VISUALIZACIÓN del catálogo de categorías de merma. El catálogo autoritativo vive en
// el backend (domain/inventory/wasteCategories.ts): la captura usa la lista que devuelve el servidor
// en /inventory/waste/options. Este mapa solo traduce códigos YA guardados (historial, bandeja) para
// que nunca se vea «WASTE_EXPIRED» donde puede decir «Caducó».
export const WASTE_CATEGORY_LABELS: Readonly<Record<string, string>> = {
  WASTE_EXPIRED: 'Caducó',
  WASTE_SPOILED: 'Se echó a perder sin caducar',
  WASTE_DAMAGED: 'Se rompió o se dañó',
  WASTE_SPILLED: 'Se cayó o se derramó',
  WASTE_PREPARATION_ERROR: 'Error al preparar',
  WASTE_SAMPLE: 'Muestra o degustación',
  WASTE_STAFF_CONSUMPTION: 'Consumo del personal',
  WASTE_OTHER: 'Otro',
  // F3: la parte del faltante de un conteo que el gerente reconoce como merma (no se captura en Mermas).
  WASTE_COUNT_DETECTED: 'Detectada en conteo',
};

/** Prefijos de las llaves técnicas de idempotencia (van en `reference`); nunca se muestran. */
export const WASTE_REQUEST_REFERENCE_PREFIX = 'waste-request:';
export const COUNT_REQUEST_REFERENCE_PREFIX = 'count-request:';

const isTechnicalReference = (reference: string) => reference.startsWith(WASTE_REQUEST_REFERENCE_PREFIX) || reference.startsWith(COUNT_REQUEST_REFERENCE_PREFIX);

/** Etiqueta amigable si `reason` es un código conocido; si no, el texto histórico tal cual (sin backfill). */
export function wasteReasonLabel(reason: string | null | undefined): string | null {
  if (!reason) return null;
  return WASTE_CATEGORY_LABELS[reason.trim()] ?? reason;
}

type NoteSource = Pick<InventoryStockTransaction, 'type' | 'reason' | 'notes' | 'reference'> & {
  reversalReason?: string | null;
  reversedAt?: string | null;
};

/**
 * Columna «Nota» del historial. Para mermas: categoría traducida + nota, y «anulada» si se anuló. Para
 * la anulación: su motivo. Para lo demás, la regla de siempre (razón, nota o referencia). Nunca
 * muestra la llave técnica de idempotencia.
 */
export function movementNote(item: NoteSource): string {
  const reference = item.reference && !isTechnicalReference(item.reference) ? item.reference : null;
  if (item.type === 'WASTE_OUT_REVERSAL') return item.reversalReason ? `Anulación de merma: ${item.reversalReason}` : 'Anulación de merma';
  if (item.type === 'WASTE_OUT') {
    const base = [wasteReasonLabel(item.reason), item.notes].filter(Boolean).join(' · ') || reference || 'Sin nota';
    return item.reversedAt ? `${base} · anulada` : base;
  }
  return item.reason || item.notes || reference || 'Sin nota';
}
